import { computed, onMounted } from "vue";
import { useStore } from "@/store";

export const AuditLogs = props => {
  const store = useStore();

  //Fetching
  const logsSummary = computed(() => store.getters["auditLogs/auditLogs"]);
  const auditLogsFetching = computed(() => store.getters["auditLogs/isBusy"]);

  //Changes related operations and commits
  function fetchAuditLogs(applicationId) {
    store.dispatch("auditLogs/getAuditLogs", { applicationId });
  }

  onMounted(() => {
    store.commit("auditLogs/setApplicationId", props.applicationId);
    fetchAuditLogs(props.applicationId);
  });
  return {
    logsSummary,
    auditLogsFetching
  };
};
